import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminPanelClinics from 'components/templates/admin/panel/clinics';

const AdminClinics = () => {
  const adminPanelClinics = useSelector((state) => state.adminPanelClinics);
  const {
    adminPanelClinics: { getClinics, reset: resetClinics },
  } = useDispatch();

  const getClinicsCallBack = useCallback(() => {
    getClinics({});
  }, [adminPanelClinics.filters]);

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      resetClinics();
    };
  }, []);

  useEffect(() => {
    getClinicsCallBack();
  }, [getClinicsCallBack]);

  return (
    <Container>
      <AdminHeader />
      <AdminPanelClinics />
    </Container>
  );
};

export default AdminClinics;
